// Attention!
// Do not edit directly! The hardcoded values of these tokens are token references
// that get resolved when the .js/d.ts files are being generated from the token JSON files.
export const SYS_BREAKPOINT_XS = '320px';
export const SYS_BREAKPOINT_SM = '375px';
export const SYS_BREAKPOINT_MD = '768px';
export const SYS_BREAKPOINT_LG = '1024px';
export const SYS_BREAKPOINT_XL = '1440px';
export const SYS_BREAKPOINT_2_XL = '1920px';
export const SYS_MAX_CONTENT_WIDTH = '1920px';
export const SYS_SIZE_FIXED_0 = '0px';
export const SYS_SIZE_FIXED_25 = '1px';
export const SYS_SIZE_FIXED_50 = '2px';
export const SYS_SIZE_FIXED_75 = '3px';
export const SYS_SIZE_FIXED_100 = '4px';
export const SYS_SIZE_FIXED_125 = '5px';
export const SYS_SIZE_FIXED_150 = '6px';
export const SYS_SIZE_FIXED_200 = '8px';
export const SYS_SIZE_FIXED_250 = '10px';
export const SYS_SIZE_FIXED_300 = '12px';
export const SYS_SIZE_FIXED_400 = '16px';
export const SYS_SIZE_FIXED_450 = '18px';
export const SYS_SIZE_FIXED_500 = '20px';
export const SYS_SIZE_FIXED_600 = '24px';
export const SYS_SIZE_FIXED_700 = '28px';
export const SYS_SIZE_FIXED_800 = '32px';
export const SYS_SIZE_FIXED_900 = '36px';
export const SYS_SIZE_FIXED_1000 = '40px';
export const SYS_SIZE_FIXED_1200 = '48px';
export const SYS_SIZE_FIXED_1400 = '56px';
export const SYS_SIZE_FIXED_1600 = '64px';
export const SYS_SIZE_FIXED_1800 = '72px';
export const SYS_SIZE_FIXED_2000 = '80px';
export const SYS_SIZE_FIXED_2100 = '84px';
export const SYS_SIZE_FIXED_2400 = '96px';
export const SYS_SIZE_FIXED_2600 = '104px';
export const SYS_SIZE_FIXED_2700 = '108px';
export const SYS_SIZE_FIXED_3000 = '120px';
export const SYS_SIZE_FIXED_3200 = '128px';
export const SYS_SIZE_FIXED_3400 = '136px';
export const SYS_SIZE_FIXED_3600 = '144px';
export const SYS_SIZE_FIXED_4800 = '192px';
export const SYS_SIZE_FIXED_6000 = '240px';
export const SYS_SIZE_FIXED_8000 = '320px';
export const SYS_SIZE_FIXED_MAX = '999px';
//# sourceMappingURL=sizing.generated.js.map